// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@revvsales/components";

// Component Imports

class OptionsMenu extends Component {
  state = {};

  render() {
    return (
      <div className="btn-group dropleft optionmenu">
        <span
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          className="pipelinewrappercard-actionsmenu dropdown-toggle">
          <FontAwesomeIcon icon={["far", "ellipsis-h"]} />
        </span>
        <div className="dropdown-menu optionsmenu-dropdown">
          {this.props.options.map(option => (
            <Button
              className="dropdown-item optionsmenu-dropdown-item"
              key={option.name}
              onClick={() => option.action(option.argument)}
              data-test={`optionsmenu-${option.name}-btn`}>
              <i>
                <FontAwesomeIcon icon={["far", `${option.ico}`]} />
              </i>
              {option.name}
            </Button>
          ))}
        </div>
      </div>
    );
  }
}

export default OptionsMenu;



// WEBPACK FOOTER //
// ./src/commonComponents/OptionsMenu/OptionsMenu.js